module.exports = __webpack_public_path__ + "img/loading.c987d7a0.gif";